import OrganizationalAuctionJSON from './OrganizationalAuction.json';

const contract = require('@truffle/contract');

export default contract({
  abi: OrganizationalAuctionJSON.abi,
});
